"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 19c-1.0824 0-2.3196-.6937-3.3311-2.0143C4.6724 15.6847 4 13.8968 4 12c0-3.8094 2.9078-8 8-8 2.5464 0 4.5318 1.14 5.8993 2.7238C19.2852 8.329 20 10.3507 20 12c0 3.2393-1.6147 5.1824-1.74 5.3274l1.4822 1.3484C21.3175 16.9163 22 14.3059 22 12c0-2.1632-.9103-4.6414-2.5869-6.5832C17.7182 3.4538 15.2036 2 12 2 5.5923 2 2 7.3095 2 12c0 2.3532.8276 4.5653 2.0811 6.2018C5.3196 19.8187 7.0824 21 9 21c1.9035 0 4-1.2429 4-3.5v-.626c1.7252-.4441 3-2.0102 3-3.874v-3h-1V7h-2v3h-2V7H9v3H8v3c0 1.8638 1.2748 3.4299 3 3.874v.626c0 .7429-.7412 1.5-2 1.5zm3-4c1.1046 0 2-.8954 2-2v-1h-4v1c0 1.1046.8954 2 2 2z"
  })];
};

exports.default = _default;